module.exports = __webpack_public_path__ + "img/195.463b8b66.jpg";